import { create } from 'lodash'
import calendarioService from '../services/calendario.service'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const {
	getEventos,
	getUsuariosCalendarios,
	getEventosUsuario,
	authMicrosoft,
	createEvento,
	updateEvento,
	deleteEvento,
} = calendarioService()

export default {
	data() {
		return {
			loading: {
				novoEvento: false,
				atualizaEvento: false,
				deletaEvento: false,
			},
			error: {
				novoEvento: null,
				atualizaEvento: null,
				deletaEvento: null,
			},
		}
	},
	methods: {
		async buscarEventos(params = {}) {
			const response = await getEventos(params)

			if (response && response.results) {
				return response?.results || []
			}
			return null
		},

		async buscarUsuariosCalendarios() {
			const response = await getUsuariosCalendarios()

			if (response && response.value) {
				return response?.value || []
			}
			return null
		},

		formatarEventos(eventosBrutos) {
			if (eventosBrutos === null) {
				return null
			}

			const statusEventos = {
				accepted: 'aceito',
				Declined: 'recusado',
				none: 'não respondeu',
			}

			return eventosBrutos?.map((evento) => {
				const membrosEventos = evento.attendees.map((attendee) => ({
					email: attendee.emailAddress.address,
					status: statusEventos[attendee.status.response] || 'desconhecido',
				}))

				let dataEventoInicio, dataEventoFim, startEvento, endEvento

				if (evento.isAllDay) {
					dataEventoInicio = dayjs(evento.start?.dateTime || evento.start)
						.startOf('day')
						.toDate()
					dataEventoFim = dayjs(evento.end?.dateTime || evento.end)
						.startOf('day')
						.toDate()
					startEvento = dayjs(evento.start?.dateTime || evento.start)
						.utc(evento.start?.dateTime || evento.start)
						.utcOffset(180)
						.format('YYYY-MM-DDTHH:mm:ss')
					endEvento = dayjs(evento.end?.dateTime || evento.end)
						.utc(evento.end?.dateTime || evento.end)
						.utcOffset(180)
						.format('YYYY-MM-DDTHH:mm:ss')
				} else {
					dataEventoInicio = dayjs(evento.start?.dateTime || evento.start)
						.utc(evento.start?.dateTime || evento.start)
						.utcOffset(-180)
						.toDate()
					dataEventoFim = dayjs(evento.end?.dateTime || evento.end)
						.utc(evento.end?.dateTime || evento.end)
						.utcOffset(-180)
						.toDate()
					startEvento = dayjs(evento.start?.dateTime || evento.start)
						.utc(evento.start?.dateTime || evento.start)
						.utcOffset(-180)
						.format('YYYY-MM-DDTHH:mm:ss')
					endEvento = dayjs(evento.end?.dateTime || evento.end)
						.utc(evento.end?.dateTime || evento.end)
						.utcOffset(-180)
						.format('YYYY-MM-DDTHH:mm:ss')
				}

				return {
					id: evento.id,
					title: evento.subject,
					start: startEvento,
					end: endEvento,
					allDay: evento.allDay ?? false,
					url: evento.webLink || undefined,
					location: evento.location || undefined,
					idEventoOriginal: evento.id,
					titulo: evento.subject,
					dataEventoInicio: dataEventoInicio || evento.start,
					dataEventoFim: dataEventoFim || evento.end,
					localEvento: evento.location?.displayName || '',
					isDiaInteiro: evento.isAllDay || false,
					isOrganizador: evento.isOrganizer || false,
					membrosEventos,
					isTeams: evento.isOnlineMeeting || false,
					urlTeams: evento.onlineMeeting?.joinUrl || null,
					descricaoEvento: this.limparTextoDeEmail(evento.bodyPreview) || '',
					dataLembrete: evento.reminderMinutesBeforeStart || null,
					atendimento_data: evento.atendimento_data || null,
					isEventoPassado: this.diaJaPassou(dataEventoFim) || false,
				}
			})
		},

		limparTextoDeEmail(texto) {
			if (!texto) {
				return ''
			}

			const regexRodape = /\s*_{20,}[\s\S]*/

			return texto.replace(regexRodape, '').trim()
		},

		filtrarPorData(eventos, data) {
			return eventos.filter((ev) => ev.start?.startsWith(data))
		},

		agruparPorDia(eventos) {
			return eventos.reduce((acc, ev) => {
				const dia = ev.start?.substring(0, 10)
				if (!acc[dia]) acc[dia] = []
				acc[dia].push(ev)
				return acc
			}, {})
		},

		diaJaPassou(data) {
			const agora = dayjs()
			const dataComparar = dayjs(data)
			return dataComparar.isBefore(agora)
		},

		async buscarEventosFormatados(params = {}) {
			const eventosBrutos = await this.buscarEventos(params)
			return this.formatarEventos(eventosBrutos)
		},

		async buscarEventosUsuarioSelecionadoFormatados(params = {}) {
			const eventos = await getEventosUsuario(params)
	
			return this.formatarEventos(eventos?.value)
		},

		async calendarioAuth() {
			return await authMicrosoft()
		},

		async criarEvento(data) {
			try {
				this.loading.novoEvento = true
				this.error.novoEvento = null
				const response = await createEvento(data)
				return response
			} catch (error) {
				this.error.novoEvento = error
				console.error('Erro ao criar evento:', error)
			} finally {
				this.loading.novoEvento = false
			}
		},

		async atualizarEvento(data) {
			try {
				this.loading.atualizaEvento = true
				this.error.atualizaEvento = null
				const response = await updateEvento(data)
				return response
			} catch (error) {
				this.error.atualizaEvento = error
				console.error('Erro ao atualizar evento:', error)
			} finally {
				this.loading.atualizaEvento = false
			}
		},

		async deletarEvento(id, dataId) {
			try {
				this.loading.deletaEvento = true
				this.error.deletaEvento = null
				const response = await deleteEvento(id, dataId)
				return response
			} catch (error) {
				this.error.deletaEvento = error
				console.error('Erro ao deletar evento:', error)
			} finally {
				this.loading.deletaEvento = false
			}
		},
	},
}
